import { render, staticRenderFns } from "./StepTowSVG.vue?vue&type=template&id=3f2acf86"
import script from "./StepTowSVG.vue?vue&type=script&lang=js"
export * from "./StepTowSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports